import { SharedErrors } from 'web_core_library';
import { NO_ALERT_TYPE } from '../base/types';

export type HighscoreFilter = 'friends' | 'all';

export interface IUserRanking {
  uid: number;
  name: string;
  score: number;
  ranking: number;
  picture?: string;
}

export interface IHighscoresApiResponse {
  page: number;
  totalUsers: number;
  userList: IUserRanking[];
  currentUser: IUserRanking;
}

export class HighscoresError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, HighscoresError.prototype);
    this.feature = 'Highscores';
    this.errorType = NO_ALERT_TYPE;
  }
}

export interface IRadioButtonItem {
  key: string;
  title: string;
}

export interface ILoadHighscoresPayload {
  exerciseId: string;
  isChallenge: boolean;
}

export interface IUpdateHighsciresPayload {
  currentUser: IUserRanking | null;
  totalUsers: number;
  userList: IUserRanking[];
}
